import React, { useState } from "react";
import Picker from "emoji-picker-react";
import { SmileOutlined } from "@ant-design/icons";

function EmojiPicker(props: {
  emoji?: string | null;
  onEmojiClick: (emoji: string) => void;
}) {
  const [chosenEmoji, setChosenEmoji] = useState({
    emoji: props.emoji,
  });
  const [display, setDisplay] = useState(false);

  const onEmojiClick = (_event: any, emojiObject: any) => {
    setDisplay(false);
    setChosenEmoji(emojiObject);
    props.onEmojiClick(emojiObject.emoji);
  };

  return (
    <div
      onClick={() => {
        if (!display) {
          setDisplay(true);
        }
      }}
    >
      {chosenEmoji.emoji ? (
        <div className={"emoji-box"}>{chosenEmoji.emoji}</div>
      ) : (
        <div className={"emoji-box"}>
          <SmileOutlined />
        </div>
      )}
      {display && <Picker onEmojiClick={onEmojiClick} />}
    </div>
  );
}

export default EmojiPicker;
